import { data } from '../../svg/Resize/data';
import { makeIcon } from '../makeIcon';

export const Resize = makeIcon(data, 'resize', 'Resize');

export default Resize;
